import {languageSpecificSettingOverrides} from './language-specific-setting-override';
import {languageConstants} from './language-constants';

const defaultLanguageCode = languageConstants.languages[languageConstants.default];

export default {
    accessibility: {
        aria : {
            inputBox:  languageSpecificSettingOverrides[defaultLanguageCode]["accessibility.aria.inputBox"],
            personaLabel: languageSpecificSettingOverrides[defaultLanguageCode]["accessibility.aria.personaLabel"],
            conversationHistoryLabel: languageSpecificSettingOverrides[defaultLanguageCode]["accessibility.aria.conversationHistoryLabel"],
            toolbar: languageSpecificSettingOverrides[defaultLanguageCode]["accessibility.aria.toolbar"],
            feedbackOverlay: languageSpecificSettingOverrides[defaultLanguageCode]["accessibility.aria.feedbackOverlay"],
            minimize : languageSpecificSettingOverrides[defaultLanguageCode]["accessibility.aria.minimize"],
        },
    },
};




// WEBPACK FOOTER //
// ./settings/accessibility.ts